module.exports = __webpack_public_path__ + "static/assets/0268b97497d5b64d3ef03b7f7584a1de.gif";